import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogTitle,
  Autocomplete,
  DialogActions,
  DialogContent,
  CircularProgress
} from '@mui/material';
import useModalCadastroContaHook from '../../hooks/useModalCadastroContaHook';

const ModalCadastroConta = ({ open, onClose, buscarContasCorrentes }) => {
  const {
    form,
    errors,
    lstBancos,
    bancoValue,
    lstAgencias,
    agenciaValue,
    handleSubmit,
    loadingBancos,
    loadingAgencias,
    handleBancoChange,
    handleContaChange,
    loadingBtnCadastrar,
    handleAgenciaChange,
    handleDigContaChange
  } = useModalCadastroContaHook({ open, onClose, buscarContasCorrentes });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Criar conta bancária</DialogTitle>

      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Preencha os dados da sua conta
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={lstBancos}
              loading={loadingBancos}
              value={bancoValue}
              onChange={handleBancoChange}
              disablePortal
              noOptionsText="Nenhum banco encontrado."
              loadingText="Carregando..."
              clearText="Limpar"
              isOptionEqualToValue={(option, value) =>
                String(option?.CODBANCO) === String(value?.CODBANCO)
              }
              getOptionLabel={option => {
                if (!option) return '';
                const cod = option.CODBANCO ?? '';
                const nome = option.NOME ?? '';
                return `${cod} - ${nome}`.trim();
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Banco"
                  required
                  error={!!errors.CODBANCO}
                  helperText={errors.CODBANCO}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              disablePortal
              options={lstAgencias}
              loading={loadingAgencias}
              value={agenciaValue}
              onChange={handleAgenciaChange}
              disabled={!form.CODBANCO}
              noOptionsText="Nenhuma agência encontrada."
              loadingText="Carregando..."
              clearText="Limpar"
              isOptionEqualToValue={(option, value) =>
                String(option?.CODAGENCIABANCO) === String(value?.CODAGENCIABANCO)
              }
              getOptionLabel={option => {
                if (!option) return '';
                const cod = option.CODAGENCIABANCO ?? '';
                const nome = option.NOME ?? '';
                return `${cod} - ${nome}`.trim();
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Agência"
                  required
                  error={!!errors.CODAGENCIABANCO}
                  helperText={errors.CODAGENCIABANCO}
                />
              )}
            />
          </Grid>

          <Grid item xs={8}>
            <TextField
              fullWidth
              label="Conta"
              name="CODCC"
              value={form.CODCC}
              onChange={handleContaChange}
              required
              error={!!errors.CODCC}
              helperText={errors.CODCC}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              fullWidth
              label="Dígito da conta"
              name="DIGCC"
              value={form.DIGCC}
              onChange={handleDigContaChange}
              required
              error={!!errors.DIGCC}
              helperText={errors.DIGCC}
              inputProps={{
                maxLength: 1
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="dialog-conta__actions">
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          className="dialog-conta__btn-cancelar"
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          className="dialog-conta__btn-escolher box-icone"
          disabled={loadingBtnCadastrar}
        >
          {!loadingBtnCadastrar && <>Cadastrar conta &nbsp;</>}
          {loadingBtnCadastrar && (
            <>
              Cadastrando a conta &nbsp;
              <CircularProgress size={20} color="inherit" />
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCadastroConta;
